var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconAdmin = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-3.25 -2.167)" },
                React.createElement("path", { d: "M26.9,26v-2.2c0-2.4-1.9-4.3-4.3-4.3h-8.7c-2.4,0-4.3,1.9-4.3,4.3V26" }),
                React.createElement("path", { d: "M22.6,10.8c0,2.4-1.9,4.3-4.3,4.3s-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3l0,0\n\t\tC20.6,6.5,22.6,8.5,22.6,10.8z" }),
                React.createElement("path", { strokeWidth: "1.4", d: "M18.7,17.7l-0.7,10.1" }),
                React.createElement("path", { strokeWidth: "1.4", d: "M18.1,17.7l0.7,10.1" })))));
});
export default IconAdmin;
//# sourceMappingURL=IconAdmin.js.map